module.exports = __webpack_public_path__ + "static/Gatsby_Balloon-19053a8b0984a333cffcf2b7d7a5808d.png";